// A best practice for URL structures is to define
// long-names with dash instead of underscores:
// https://developers.google.com/search/docs/crawling-indexing/url-structure
const routes = {
  home: '/',
  root: '/dashboard',
  login: '/login',
  dashboard: '/dashboard',
  documentation: '/documentation',
  documentationCreateGeofence: '/documentation/general/create-geofence',
  documentationCollectTeamData: '/documentation/security/collect-team-data',
  documentationUpdateLicense: '/documentation/security/update-license',
  documentationEnterTruck: '/documentation/maintenance/enter-truck',
  documentationCompleteForm: '/documentation/maintenance/complete-form',
  maintenance:
    '/maintenance/:type(maintenance-initial|preventive|predictive|ongoing|completed|permanence|anomaliesVolvo|scheduled)',
  maintenanceInitial: '/maintenance/maintenance-initial',
  maintenancePreventive: '/maintenance/preventive',
  maintenancePredictive: '/maintenance/predictive',
  maintenanceOngoing: '/maintenance/ongoing',
  maintenanceCompleted: '/maintenance/completed',
  maintenancePermanence: '/maintenance/permanence',
  maintenanceAnomaliesVolvo: '/maintenance/anomaliesVolvo',
  maintenanceScheduled: '/maintenance/scheduled',
  monitoring:
    '/monitoring/:type(monitoring-initial|map|mapv2|performance|last-shift|charging|transfer-b57-discharging|discharging|transfer-b57|idle|effective-time-driver|punctures|composting|roller|can|geofenceg1|lowvelocity|despacho|acopios|cycleanomaly|tankertruck)',
  monitoringInitial: '/monitoring/monitoring-initial',
  monitoringmap: '/monitoring/map',
  monitoringmapv2: '/monitoring/mapv2',
  monitoringPerf: '/monitoring/performance',
  monitoringLastShift: '/monitoring/last-shift',
  monitoringCharg: '/monitoring/charging',
  monitoringTUnload: '/monitoring/transfer-b57-discharging',
  monitoringDischarging: '/monitoring/discharging',
  monitoringTLoad: '/monitoring/transfer-b57',
  monitoringIdle: '/monitoring/idle',
  monitoringEffectiveTimeDriver: '/monitoring/effective-time-driver',
  monitoringPunctures: '/monitoring/punctures',
  monitoringComposting: '/monitoring/composting',
  monitoringRoller: '/monitoring/roller',
  monitoringCan: '/monitoring/can',
  monitoringGeofenceG1: '/monitoring/geofenceg1',
  monitoringLowVelocity: '/monitoring/lowvelocity',
  monitoringDespacho: '/monitoring/despacho',
  monitoringAcopios: '/monitoring/acopios',
  monitoringCycleAnomaly: '/monitoring/cycleanomaly',
  monitoringTankerTruck: '/monitoring/tankertruck',
  productivity:
    '/productivity/:type(productivity-initial|historic|daily|weekly|monthly|idle|punctures|asarco|speed|kpitree|breakfast|speedgeofence|dailyturn|cyclewalls|metrics|pto|trimble|acopios-historicos)',
  productivityInitial: '/productivity/productivity-initial',
  productivityDaily: '/productivity/daily',
  productivityWeekly: '/productivity/weekly',
  productivityHistoric: '/productivity/historic',
  productivityMonthly: '/productivity/monthly',
  productivityIdle: '/productivity/idle',
  productivityFlatTire: '/productivity/punctures',
  productivityAsarco: '/productivity/asarco',
  productivitySpeed: '/productivity/speed',
  producivityKpiTree: '/productivity/kpitree',
  productivityBreakfast: '/productivity/breakfast',
  productivitySpeedGeofence: '/productivity/speedgeofence',
  producivityDailyTurn: '/productivity/dailyturn',
  productivityCycleWalls: '/productivity/cyclewalls',
  productivityMetrics: '/productivity/metrics',
  productivityPto: '/productivity/pto',
  productivityTrimble: '/productivity/trimble',
  productivityAcopios: '/productivity/acopios-historicos',
  security:
    '/security/:type(security-initial|truck-approach|velocity-violation|velocity-historic|can|fatigue|suddenstops|sensors-count|brake-retarder|train|camera)',
  securityInitial: '/security/security-initial',
  securityTruckApproach: '/security/truck-approach',
  securityVelocityViolation: '/security/velocity-violation',
  securityVelocityHistoric: '/security/velocity-historic',
  securityCan: '/security/can',
  securityFatigue: '/security/fatigue',
  securitySuddenStops: '/security/suddenstops',
  securitySensorsCount: '/security/sensors-count',
  securityBrake: '/security/brake-retarder',
  securityTrain: '/security/train',
  securityCamera: '/security/camera',
  records:
    '/records/:type(records-initial|driver|machines|geofences|routes|gates)',
  recordsInitial: '/records/records-initial',
  recordsDriver: '/records/driver',
  recordsMachines: '/records/machines',
  recordsGeofenches: '/records/geofences',
  recordsRoutes: '/records/routes',
  recordsGates: '/records/gates',
  database:
    '/database/:type(database-initial|gps|canbus|productivity|hourmeter)',
  databaseInitial: '/database/database-initial',
  databaseGps: '/database/gps',
  databaseCanBus: '/database/canbus',
  databaseProductivity: '/database/productivity',
  databaseHourmeter: '/database/hourmeter',
  users: '/users/:type(users-initial|recomendations)',
  usersInitial: '/users/users-initial',
  usersRecomendations: '/users/recomendations',
  map: '/map',
  fronts: '/fronts',
  userManual: '/user-manual',
  notifications: '/notifications',
  diagram: '/diagram',
  devices: '/devices',
  passwordRecovery: '/recover-password',
  kepler: '/cycles-map',
  cesium: '/cesium',
};

export default routes;
